/**
 * Purpose: Searchable society picker for create/edit forms with long society lists.
 * Inputs: societies array, value, onChange, loading/disabled flags.
 * Outputs: SearchableSelect wired with society id/name labels.
 */
import React, { useMemo } from 'react';
import SearchableSelect from './SearchableSelect';
import { societyListToSelectOptions } from '../../utils/filterSelectOptions';

const SocietySearchableSelect = ({
  societies = [],
  value,
  onChange,
  name = 'society',
  id = 'society',
  label = 'Society *',
  hideLabel = false,
  loading = false,
  disabled = false,
  required = true,
  showCity = true,
  emptyLabel = 'Select a society',
  helperText = null,
  className = '',
}) => {
  const options = useMemo(
    () => societyListToSelectOptions(societies, { showCity }),
    [societies, showCity],
  );

  return (
    <div className={className}>
      <SearchableSelect
        id={id}
        name={name}
        label={hideLabel ? undefined : label}
        value={value}
        onChange={onChange}
        options={options}
        searchable
        required={required}
        disabled={disabled || loading}
        loading={loading}
        loadingLabel="Loading societies…"
        emptyOption={{ value: '', label: emptyLabel }}
        searchPlaceholder="Search societies…"
      />
      {helperText ? (
        <p className="mt-1 text-xs text-gray-500">{helperText}</p>
      ) : null}
    </div>
  );
};

export default SocietySearchableSelect;
